import { ApplicationConfig, provideZoneChangeDetection, enableProdMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, HTTP_INTERCEPTORS, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './services/auth/auth.service';
import { environment } from '../environments/environment';
import { provideToastr } from 'ngx-toastr';

const INTERCEPTOR = {provide:HTTP_INTERCEPTORS, useClass:AuthInterceptor, multi:true};

if(environment.production) {
  enableProdMode();
}

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), provideHttpClient(withInterceptorsFromDi()), INTERCEPTOR, provideToastr({})]
};
